<template>
	<modal titulo="Auditoria" :loading="loading" id="modal-auditoria">

    <p class="text-small mb-3" v-if="auditoria && auditoria.login"><b>Login Usuário: </b> {{auditoria.login}}</p>
    <div class="w-100"></div>
    <auditoria-details-content :auditoria="auditoria" :formatters="formatters" v-if="!loading" />

  </modal>
</template>

<script>
  import AuditoriaBusiness from "@/business/AuditoriaBusiness.js";
  import FrontBusiness from "@/business/FrontBusiness";
  import Modal from "@/components/Modal";
  import AuditoriaDetailsContent from "@/v2/components/Auditoria/AuditoriaDetailsContent.vue";

  export default {

    name: "AuditoriaDetails",
    components: {AuditoriaDetailsContent, Modal},
    props: {
      id : String,
      formatters: Array
    },

    modal:{
      width: 1100
    },

    data() {
      return {
        loading: true,
        auditoria: null,
      }
    },

    computed:{
      show(){
        return !this.loading && Object.keys(this.rows).length;
      }
    },

    async mounted(){
      this.auditoria = await AuditoriaBusiness.getById(this.id);
      this.loading = false;
    },

    methods:{
      close() {
        FrontBusiness.closeModal();
      },
    }

  }
</script>
